import { render, staticRenderFns } from "./SectionTrainer.vue?vue&type=template&id=5adfae9d&scoped=true&"
import script from "./SectionTrainer.vue?vue&type=script&lang=js&"
export * from "./SectionTrainer.vue?vue&type=script&lang=js&"
import style0 from "./SectionTrainer.vue?vue&type=style&index=0&id=5adfae9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adfae9d",
  null
  
)

export default component.exports